export const storePrefix = 'shopcart'
